import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/download-button.css.js";
import withStyles from "components/with-styles";
import DownloadIcon from "./parts/download-icon";
import DownloadText from "./parts/download-text";
import DownloadNotAvailable from "./parts/download-not-available";

const DownloadButton = ({ url, onlyIcon = false, classes, onClick, disabled, disabledClass }) => {
  if (!Boolean(url) && !Boolean(onClick)) {
    return <DownloadNotAvailable showIcon={onlyIcon} />;
  }

  const Content = () => (
    <>
      <DownloadIcon compactStyle={!onlyIcon} disabled={disabled} disabledClass={disabledClass} />
      <DownloadText show={!onlyIcon} />
    </>
  );

  return disabled ? (
    <Content />
  ) : (
    <a className={classes.link} onClick={onClick} target="_blank" rel="noopener noreferrer" href={url || undefined}>
      <Content />
    </a>
  );
};

DownloadButton.propTypes = {
  /**
   * Url del icono
   **/
  url: PropTypes.string,
  /**
   * Handler de click del enlace
   **/
  onClick: PropTypes.func,
  /**
   * No muestra el texto de descarga
   **/
  onlyIcon: PropTypes.bool,
  /**
   * Muestra el enlace deshabilitado
   **/
  disabled: PropTypes.bool,
  /**
   * Reemplaza la clase de deshabilitado por defecto
   **/
  disabledClass: PropTypes.string,
};

export default withStyles(styles)(DownloadButton);
